import { render, staticRenderFns } from "./AnamnesiGenericaViewComponent.vue?vue&type=template&id=f91b5a22"
import script from "./AnamnesiGenericaViewComponent.vue?vue&type=script&lang=js"
export * from "./AnamnesiGenericaViewComponent.vue?vue&type=script&lang=js"
import style0 from "./AnamnesiGenericaViewComponent.vue?vue&type=style&index=0&id=f91b5a22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports